import { Request,BaseApiUrl } from "./api";

// 列表
export const getProdTaskListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdTask/get`, { params: params });
};


//新增
export const addProdTask = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdTask/Post`, params);
};
//编辑
export const editProdTask = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdTask/Put`, params);
};

// 获取任务单新增编辑基础数据
export const getGetProdTaskBaseData = (params) => {
    return Request.get(`${BaseApiUrl}/api/ProdTask/GetProdTaskBaseData`);
  };
  
//批量删除
export const batchDeleteProdTask = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdTask/BatchDelete`, params);
};
// export const batchDeleteProdTask = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/ProdTask/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
// 列表
export const getTaskByRecipeCode = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdTask/GetTaskByRecipeCode`, { params: params });
};

// 列表
export const checkProdTask = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/CheckProdTask`, { params: params });
};